import React, { useEffect } from 'react';
import {
    Box,
    Typography,
    Container,
    CircularProgress
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const Admin: React.FC = () => {
    const { t } = useTranslation();

    useEffect(() => {
        // Redirect to Strapi admin panel
        const strapiAdminUrl = `${import.meta.env.VITE_STRAPI_URL || 'http://localhost:1337'}/admin`;

        // Show loading briefly then redirect
        const timer = setTimeout(() => {
            window.location.href = strapiAdminUrl;
        }, 1500);

        return () => clearTimeout(timer);
    }, []);

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center'
                }}
            >
                <CircularProgress
                    size={60}
                    sx={{
                        mb: 3,
                        color: 'primary.main'
                    }}
                />

                <Typography
                    variant="h5"
                    component="h1"
                    gutterBottom
                    sx={{
                        fontWeight: 600
                    }}
                >
                    {t('redirecting_to_admin')}
                </Typography>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mb: 3 }}
                >
                    {t('strapi_redirect_message')}
                </Typography>

                <Typography
                    variant="body2"
                    color="text.disabled"
                >
                    {t('manual_redirect_note')}
                    <a
                        href={`${import.meta.env.VITE_STRAPI_URL || 'http://localhost:1337'}/admin`}
                        style={{
                            marginLeft: '4px',
                            color: 'inherit',
                            textDecoration: 'underline'
                        }}
                    >
                        {t('here')}
                    </a>
                </Typography>
            </Box>
        </Container>
    );
};

export default Admin;